import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { postActivityLog } from '../services/postActivityLog.service';

/**
 * Logs that the current user opened a project (VIEW_PROJECT). Best-effort:
 * createAsyncThunk routes any failure to a `rejected` action, so a logging error
 * never surfaces to the user. Dispatched by the project-view middleware on
 * project entry, so it covers the dashboard and every project sub-page.
 */
export const logProjectOpened = createAsyncThunk(
  'activityLog/logProjectOpened',
  async ({ projectId }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    return postActivityLog({
      projectId,
      action: 'VIEW_PROJECT',
      activeEmployerInfo,
    });
  }
);
